<template>
  <div>
    <v-navigation-drawer clipped app v-model="drawer">
      <v-list
        style="margin-top: 60px; margin-bottom: 10px"
        :class="'/dashboard' === $route.path ? 'active' : ''"
      >
        <v-list-item to="/dashboard">
          <v-img
            src="@/assets/img/home.png"
            contain
            :width="iconWidth"
            height="iconHeight"
          ></v-img>
          <v-list-item-title class="accent--text navtext"
            >Home</v-list-item-title
          >
        </v-list-item>
      </v-list>
      <div class="linkseparator"></div>

      <div
        v-if="
          $can('CAN_VIEW_CATALOGUE') ||
          $can('CAN_UPLOAD_CATALOGUE') ||
          $can('CAN_APPROVE_CATALOGUE') ||
          $can('CAN_APPROVE_CATALOGUE') ||
          $can('CAN_UPLOAD_GRN') ||
          $can('CAN_VIEW_GRN') ||
          $can('CAN_APPROVE_GRN')
        "
      >
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
          >
            <template v-slot:activator>
              <v-list-item dense class="tight-list-item">
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >Catalogue</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon class="tight-icon" slot="prependIcon" medium color="#733D29"
              >fas fa-file-invoice-dollar</v-icon
            >

            <v-list-item to="/catalogue" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Ordinary Catalogue</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/specialitycatalogue" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Speciality Catalogue</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/sweepings/upload" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Sweepings Catalogue</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
          v-if="canViewEstateBroker"
          to="/estatecuredBroker"
          active-class="accent--text"
        > -->
            <v-list-item
              v-if="canViewEstateBroker"
              to="/estatecuredBroker"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Estate Cured</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div
        v-if="
          $can('CAN_VIEW_EUDR') ||
          $can('CAN_APPROVE_EUDR') ||
          $can('CAN_APPROVE_EUDR')
        "
      >
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
            :class="currPath === 'invoice' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >EUDR</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-file-invoice-dollar</v-icon
            >
            <v-list-item to="/eudr/geomapagent" color="#733D29">
              <!-- <v-list-item to="/sla/saledates" active-class="accent--text"> -->
              <v-list-item-content>
                <v-list-item-title>Agents</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/eudr/duediligencestatement"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Due Diligence Statement</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="$can('CAN_VIEW_DDS')"
              to="/eudr/generate"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Pending DDS</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="$can('CAN_VIEW_DDS')"
              to="/eudr/confirm"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Confirm DDS</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/eudr/report"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Farmers Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="canViewFarmers || $can('CAN_VIEW_AUCTION')">
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
            :class="currPath === 'grower' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >GROWERS</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-coffee</v-icon
            >

            <!-- <v-list-item to="/grower/stock" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Stock Status</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item
              to="/grower/stock2"
              active-class="accent--text"
              v-if="canViewFarmers && canViewGrowers"
            >
              <v-list-item-content>
                <v-list-item-title>Stock Status</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/grower/non-checkoff2"
              active-class="accent--text"
              v-if="canViewFarmers && canViewGrowers"
            >
              <v-list-item-content>
                <v-list-item-title
                  >Grower Non-Check Account Statement</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
            to="/grower/non-checkoff"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Grower Non-Checkoff Account Statement</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <!-- <v-list-item to="/reports/unbulking_tracing_report" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Sales Statement Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item to="/grower/salestatement" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Sales Statement Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="canAccessFarmers">
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            :class="currPath === 'farmers' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >Farmer</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-icon slot="prependIcon" medium color="#733D29"
              >fa fa-coffee</v-icon
            >

            <v-list-item
              to="/farmers/farmers"
              active-class="accent--text"
              v-if="canViewFarmers"
            >
              <v-list-item-content>
                <v-list-item-title v-if="isFCSManager"
                  >Approve Farmer Data</v-list-item-title
                >
                <v-list-item-title v-else>Upload Farmer Data</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!--v-list-item to="/ccarf/delivery/farmer/creation" active-class="accent--text" v-if="canViewFarmers">
              <v-list-item-content>
                <v-list-item-title>Create Farmer</v-list-item-title>
                </v-list-item-content>
            </v-list-item-->
            <v-list-item
              to="/ccarf/delivery/farmer/creation"
              active-class="accent--text"
              ><v-list-item-content>
                <v-list-item-title v-if="isFCSManager">
                  Approve Created Farmer</v-list-item-title
                >
                <v-list-item-title v-else>Create Farmer</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/farmers/farmercompany"
              active-class="accent--text"
              v-if="canViewFarmers"
            >
              <v-list-item-content>
                <v-list-item-title v-if="isFCSManager"
                  >Approve Farmer Company</v-list-item-title
                >
                <v-list-item-title v-else
                  >Upload Farmer Company</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/farmers/view"
              active-class="accent--text"
              v-if="canViewFarmers"
            >
              <v-list-item-content>
                <v-list-item-title>View Farmers</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/farmers/summary"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_FACTORY_DATA')"
            >
              <v-list-item-content>
                <v-list-item-title>Farmers Summary</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/farmers/limits/"
              active-class="accent--text"
              v-if="canViewFarmers"
            >
              <v-list-item-content>
                <v-list-item-title>Farmer Limits</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/farmers/paymentSchedule/"
              active-class="accent--text"
              v-if="$can('CAN_GENERATE_SCHEDULE')"
            >
              <v-list-item-content>
                <v-list-item-title>Payment Schedule</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/farmers/paymentSchedule/retries"
              active-class="accent--text"
              v-if="$can('CAN_RETRY_FARMER_PAYMENT')"
            >
              <v-list-item-content>
                <v-list-item-title
                  >Retry Failed Farmer Payments</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/farmers/paymentSchedule/retries/approve"
              active-class="accent--text"
              v-if="$can('CAN_APPROVE_FARMER_PAYMENT_RETRIES')"
            >
              <v-list-item-content>
                <v-list-item-title
                  >Approve Farmer Payment Retries</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/farmers/schedule/view"
              active-class="accent--text"
              v-if="$can('CAN_APPROVE_SCHEDULE')"
            >
              <v-list-item-content>
                <v-list-item-title>Approve Schedule</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/farmers/update/approve"
              active-class="accent--text"
              v-if="$can('CAN_APPROVE_FARMER')"
            >
              <v-list-item-content>
                <v-list-item-title>Update Farmer Requests</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/farmers/communalRates/view"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_COMMUNAL_RATES')"
            >
              <v-list-item-content>
                <v-list-item-title>View Schedules</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/farmers/payments/statement"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_FARMER_STATEMENT')"
            >
              <v-list-item-content>
                <v-list-item-title>Farmer Statements</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="canUploadDelivery">
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            :class="currPath === 'delivery' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >Cherry</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-leaf</v-icon
            >

            <!--            <v-icon slot="prependIcon" medium color="#733D29">fa fa-circle</v-icon>-->

            <v-list-item
              to="/ccarf/delivery/cherry/files"
              active-class="accent--text"
              v-if="canUploadCherryDelivery"
            >
              <v-list-item-content>
                <v-list-item-title v-if="$can('CAN_UPLOAD_LIMITS')"
                  >Upload Cherry</v-list-item-title
                >
                <v-list-item-title v-else>Approve Cherry</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/ccarf/delivery/cherry/creation"
              active-class="accent--text"
              ><v-list-item-content>
                <v-list-item-title v-if="$can('CAN_CREATE_CHERRY_RATE')"
                  >Create Cherry</v-list-item-title
                >
                <v-list-item-title v-else
                  >Approve Created Cherry</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/farmers/cherry/summaryReport"
              active-class="accent--text"
              v-if="canUploadCherryDelivery"
            >
              <v-list-item-content>
                <v-list-item-title>View Cherry Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/ccarf_rate/create_ccarf_rate"
              active-class="accent--text"
              v-if="canUploadLimits"
            >
              <v-list-item-content>
                <v-list-item-title>Create/Edit Rate</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/ccarf_rate/create_ccarf_rate"
              active-class="accent--text"
              v-if="canUpdateCherryRate"
            >
              <v-list-item-content>
                <v-list-item-title>Approve Rate</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/ccarf/delivery/cherry/creation"
              active-class="accent--text"
              v-if="$can('CAN_APPROVE_CHERRY_RATE')"
            >
              <v-list-item-content>
                <v-list-item-title>Approve Created Cherry</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/ccarf_rate/view_ccarf_rates"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>View Limit Rates</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="canUploadCcarfParchmentDelivery">
        <v-list
          :class="currPath === '/ccarf/delivery/parchments' ? 'active' : ''"
        >
          <v-list-item to="/ccarf/delivery/parchment/files" color="#733D29">
            <v-img
              src="@/assets/img/catalogues_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>

            <!--                  <v-img src="@/assets/img/catalogues_small.svg" contain :width="iconWidth" height="iconHeight"></v-img>-->
            <v-list-item-title class="accent--text navtext"
              >CCARF Parchment</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="canPerformOrgFunc">
        <v-list :class="'/taxtype' === $route.path ? 'active' : ''">
          <v-list-item to="/taxtype">
            <v-img
              src="@/assets/img/warrants_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
            >Tax Type</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="$can('CAN_CREATE_TIMELINE') || $can('CAN_UPDATE_TIMELINE')">
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
            :class="currPath === 'invoice' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >SLA</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-file-invoice-dollar</v-icon
            >

            <v-list-item to="/sla/saledates" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Sale Dates</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/sla/default" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Default SLA</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/sla/custom" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Custom Org SLA</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/sla/seasons" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Seasons</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="$can('CAN_VIEW_LOAN_REQUEST')">
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
            :class="currPath === 'invoice' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >LOANS</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-file-invoice-dollar</v-icon
            >
            <v-list-item to="/loan/requests" color="#733D29">
              <!-- <v-list-item to="/sla/saledates" active-class="accent--text"> -->
              <v-list-item-content>
                <v-list-item-title>Loans</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/loan/recon"
              active-class="accent--text"
              v-if="canViewReconFile"
            >
              <v-list-item-content>
                <v-list-item-title>Recon File</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>
      <div v-if="$can('CAN_VIEW_FCS_LOAN_SCHEDULE')">
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
            :class="currPath === 'invoice' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >LOAN SCHEDULE</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-file-invoice-dollar</v-icon
            >

            <v-list-item
              to="/ccarf/farmer/loan/schedule"
              active-class="accent--text"
              v-if="canViewFcsLoanSchedule"
            >
              <v-list-item-content>
                <v-list-item-title v-if="$can('CAN_UPLOAD_FCS_LOAN_SCHEDULE')"
                  >Upload Loan Schedule</v-list-item-title
                >
                <v-list-item-title v-else
                  >Approve Loan Schedule</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div
        v-if="
          $can('CAN_UPLOAD_PARCHMENT') ||
          $can('CAN_VIEW_PARCHMENT') ||
          $can('CAN_APPROVE_PARCHMENT')
        "
      >
        <v-list :class="currPath === 'parchment' ? 'active' : ''">
          <v-list-item to="/parchment">
            <v-img
              src="@/assets/img/catalogues_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
              >Parchment</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>
      <!--
      <div
        v-if="
          $can('CAN_UPLOAD_PARCHMENT') ||
          $can('CAN_VIEW_PARCHMENT') ||
          $can('CAN_APPROVE_PARCHMENT')
        "
      >
        <v-list :class="currPath === 'cleancoffee' ? 'active' : ''">
          <v-list-item to="/cleancoffee">
            <v-img
              src="@/assets/img/catalogues_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
            >Clean Coffee</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div> -->

      <div
        v-if="
          $can('CAN_UPLOAD_PARCHMENT') ||
          $can('CAN_VIEW_PARCHMENT') ||
          $can('CAN_APPROVE_PARCHMENT')
        "
      >
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
          >
            <template v-slot:activator>
              <v-list-item dense class="tight-list-item">
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >Clean Coffee</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon class="tight-icon" slot="prependIcon" medium color="#733D29"
              >fas fa-file-invoice-dollar</v-icon
            >

            <v-list-item to="/cleancoffee" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Clean File</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="canViewEstateMiller"
              to="/estatecuredMiller"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Estate Cured</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div
        v-if="
          $can('CAN_UPLOAD_GRN') ||
          $can('CAN_VIEW_GRN') ||
          $can('CAN_APPROVE_GRN') ||
          $can('CAN_VIEW_DIRECT_SALE') ||
          $can('CAN_APPROVE_DIRECT_SALE')
        "
      >
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
          >
            <template v-slot:activator>
              <v-list-item dense class="tight-list-item">
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                  >Dispatch</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon class="tight-icon" slot="prependIcon" medium color="#733D29"
            >fas fa-file-invoice-dollar</v-icon
            >

            <v-list-item
              v-if="
                $can('CAN_UPLOAD_GRN') ||
                $can('CAN_VIEW_GRN') ||
                $can('CAN_APPROVE_GRN')
              "
              to="/grnfile" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Ordinary Dispatch</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="
                $can('CAN_VIEW_DIRECT_SALE') ||
                $can('CAN_APPROVE_DIRECT_SALE')
              "
              to="/directsalegrnfile" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Direct Sale Dispatch</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

<!--      <div
        v-if="
          $can('CAN_UPLOAD_GRN') ||
          $can('CAN_VIEW_GRN') ||
          $can('CAN_APPROVE_GRN')
        "
      >
        <v-list :class="currPath === 'grnfile' ? 'active' : ''">
          <v-list-item to="/grnfile">
            <v-img
              src="@/assets/img/catalogues_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent&#45;&#45;text navtext"
              >Dispatch File</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>-->

      <!-- <div
        v-if="
          $can('CAN_VERIFY_INVOICE') ||
          $can('CAN_VIEW_INVOICE') ||
          $can('CAN_VIEW_BROKER_INVOICE') ||
          $can('CAN_CONFIRM_INVOICE') ||
          $can('CAN_REJECT_INVOICE')
        "
      >
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
            :class="currPath === 'invoice' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >INVOICES</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-file-invoice-dollar</v-icon
            >

            <v-list-item to="/invoice/confirmed" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Confirmed Invoices</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/invoice/generated"
              active-class="accent--text"
              v-if="$can('CAN_CONFIRM_INVOICE')"
            >
              <v-list-item-content>
                <v-list-item-title>Pending Confirmation</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div> -->

          <div
        v-if="canInteractWithInvoice

              "
      >
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                  >INVOICES
                  </v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon slot="prependIcon" medium color="#733D29"
            >fas fa-file-invoice-dollar
            </v-icon
            >

            <!--            <v-list>-->
            <!--              <v-list-group-->
            <!--                no-action-->
            <!--                color="#733D29"-->
            <!--                light-->
            <!--                style="margin-left: 7px"-->
            <!--                :class="currPath === 'invoice' ? 'active' : ''"-->
            <!--              >-->
            <!--                <template v-slot:activator>-->
            <!--                  <v-list-item>-->
            <!--                    <v-list-item-content>-->
            <!--                      <v-list-item-title class="accent&#45;&#45;text navtextgroup"-->
            <!--                      >Broker-Buyer Invoice</v-list-item-title-->
            <!--                      >-->
            <!--                    </v-list-item-content>-->
            <!--                  </v-list-item>-->
            <!--                </template>-->

            <v-list-item to="/invoice/confirmed" active-class="accent--text"
                         v-if="$can('CAN_VIEW_BROKER_INVOICE')"
            >
              <v-list-item-content>
                <v-list-item-title>Confirmed Invoice</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/invoice/generated"
              active-class="accent--text"
              v-if="$can('CAN_CONFIRM_INVOICE')"
            >
              <v-list-item-content>
                <v-list-item-title>Pending Confirmation</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!--            <v-list-item-->
            <!--              to="/invoice/broker/generated"-->
            <!--              active-class="accent&#45;&#45;text"-->
            <!--              v-if="$can('CAN_CONFIRM_INVOICE')"-->
            <!--            >-->
            <!--              <v-list-item-content>-->
            <!--                <v-list-item-title>GenerateBroker Invoice</v-list-item-title>-->
            <!--              </v-list-item-content>-->
            <!--            </v-list-item>-->

            <v-list-item to="/invoice/miller/view" active-class="accent--text"
                         v-if="$can('CAN_VIEW_MILLER_INVOICE')"
            >
              <v-list-item-content>
                <v-list-item-title>Miller Invoice</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
               <v-list-item to="/invoice/broker/view" active-class="accent--text"
                         v-if="$can('CAN_VIEW_BROKER_INVOICE')"
            >
              <v-list-item-content>
                <v-list-item-title>Broker Invoice</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/invoice/warehouse/view" active-class="accent--text"
                         v-if="$can('CAN_VIEW_WAREHOUSE_INVOICE')"
            >
              <v-list-item-content>
                <v-list-item-title>Warehouse Invoice</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/invoice/grower/view" active-class="accent--text"
                         v-if="$can('CAN_VIEW_GROWER_INVOICE')"
            >
              <v-list-item-content>
                <v-list-item-title>Grower Invoice</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/invoice/nce/view" active-class="accent--text"
                         v-if="$can('CAN_VIEW_NCE_INVOICE')"
            >
              <v-list-item-content>
                <v-list-item-title>NCE Invoice</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item to="/invoice/nce/view" active-class="accent--text"
                         v-if="$can('CAN_VIEW_BROKER_INVOICE')"

            >
              <v-list-item-content>
                <v-list-item-title>NCE Invoice</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>


      <div v-if="$can('CAN_CREATE_ESLIP')">
        <v-list :class="'/eslips/generate' === $route.path ? 'active' : ''">
          <v-list-item to="/eslips/generate">
            <v-img
              src="@/assets/img/invoices_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
              >Generate Eslips</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="$can('CAN_VIEW_ESLIP')">
        <v-list :class="'/eslips/buyer' === $route.path ? 'active' : ''">
          <v-list-item to="/eslips/buyer">
            <v-img
              src="@/assets/img/invoices_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
              >View Eslips</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <!-- <div
        v-if="
          $can('CAN_UPLOAD_AUCTION') ||
          $can('CAN_APPROVE_AUCTION') ||
          $can('CAN_VIEW_AUCTION')
        "
      >
        <v-list :class="'/file/auctionupload' === $route.path ? 'active' : ''">
          <v-list-item to="/file/auctionupload">
            <v-img
              src="@/assets/img/auction_results_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
              >Auction Files</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="$can('CAN_VIEW_AUCTIONRESULTS') || $can('CAN_EDIT_AUCTION')">
        <v-list :class="currPath === 'auctiondetails' ? 'active' : ''">
          <v-list-item to="/auction/result">
            <v-img
              src="@/assets/img/auction_results_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
              >Auction Results</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div> -->


       <div
        v-if="
        $can('CAN_UPLOAD_AUCTION') ||
          $can('CAN_APPROVE_AUCTION') ||
          $can('CAN_VIEW_AUCTION')
        "
      >
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
          >
            <template v-slot:activator>
              <v-list-item dense class="tight-list-item">
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >Auction</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon class="tight-icon" slot="prependIcon" medium color="#733D29"
              >fas fa-file-invoice-dollar</v-icon
            >

            <v-list-item to="/file/auctionupload" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Auction Files</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/auction/result" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Auction Result</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/broker/payout/requests" active-class="accent--text">
              <v-list-item-content>
                <v-list-item-title>Broker Schedule</v-list-item-title>
              </v-list-item-content>
            </v-list-item>


          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="$can('CAN_VIEW_PAYMENT')">
        <v-list :class="'/payment/received' === $route.path ? 'active' : ''">
          <v-list-item to="/payment/received">
            <v-img
              src="@/assets/img/invoices_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
              >Payments</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="$can('CAN_VIEW_SETTLEMENT')">
        <v-list
          :class="'/settlement/unapproved' === $route.path ? 'active' : ''"
        >
          <v-list-item to="/settlement/unapproved">
            <v-img
              src="@/assets/img/invoices_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
              >Settlements</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>
      <!-- Warrants views-->

      <div v-if="$can('CAN_VIEW_SETTLEMENT')">
        <v-list :class="'/transaction' === $route.path ? 'active' : ''">
          <v-list-item to="/transaction">
            <v-img
              src="@/assets/img/warrants_small.svg"
              contain
              :width="iconWidth"
              height="iconHeight"
            ></v-img>
            <v-list-item-title class="accent--text navtext"
              >Transactions</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="
                $can('CAN_VIEW_GROWER_SETTLEMENT_DETAILS_REPORT') ||
                $can('CAN_VIEW_GROWER_SETTLEMENT_REPORT') ||
                $can('CAN_VIEW_DSS_ACCOUNT_REPORT') ||
                $can('CAN_APPROVE_CATALOGUE') ||
                $can('CAN_VIEW_CATALOGUE') ||
                $can('CAN_UPLOAD_CATALOGUE') ||
                $can('CAN_VIEW_PENALTY_REPORT') ||
                $can('CAN_VIEW_UNBULKING_REPORT') ||
                $can('CAN_VIEW_EXCEPTION_REPORT') ||
                $can('CAN_VIEW_BROKER_REPORT') ||
                $can('CAN_VIEW_MILLER_REPORT') ||
                $can('CAN_VIEW_WAREHOUSE_REPORT') ||
                $can('CAN_VIEW_BUYER_REPORT') ||
                $can('CAN_VIEW_PAYMENT_REPORT')
              ">
        <!--add access rights 'CAN_VIEW_RESERVE'-->
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
            :class="currPath === 'reports' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >REPORTS</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-file</v-icon
            >

            <v-list-item
              to="/reports/grower_settlement_details"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_GROWER_SETTLEMENT_DETAILS_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title
                  >Growers Settlement Details</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/growers_settlement"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_GROWER_SETTLEMENT_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Grower Settlement Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/account_report"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_DSS_ACCOUNT_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Dss Account Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/sweepings_report"
              active-class="accent--text"
              v-if="
                $can('CAN_APPROVE_CATALOGUE') ||
                $can('CAN_VIEW_CATALOGUE') ||
                $can('CAN_UPLOAD_CATALOGUE')
              "
            >
              <v-list-item-content>
                <v-list-item-title>Sweepings Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/penalty-report"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_PENALTY_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Penalty Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/grower-sales-report"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_UNBULKING_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Grower Sales Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/exceptional_report"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_EXCEPTION_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Exceptional Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/broker_report"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_BROKER_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Broker Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/miller_report"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_MILLER_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Miller Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/warehouse_report"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_WAREHOUSE_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Warehouse Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/buyer_report"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_BUYER_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Buyer Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/reports/payment_report"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_PAYMENT_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>Payment Report</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="$can('CAN_VIEW_WARRANT')">
        <v-list>
          <v-list-group
            no-action
            color="#733D29"
            light
            style="margin-left: 7px"
            :class="currPath === 'reports' ? 'active' : ''"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >WARRANTS</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-file</v-icon
            >

            <v-list-item
              to="/warrant/holding/views"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_WARRANT')"
            >
              <v-list-item-content>
                <v-list-item-title>Holding Warrants</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/initiate/warrant/collection"
              active-class="accent--text"
              v-if="$can('CAN_INITATE_WARRANT_COLLECTION')"
            >
              <v-list-item-content>
                <v-list-item-title>Initiate Collection</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/approve/warrant/collection"
              active-class="accent--text"
              v-if="$can('CAN_APPROVE_WARRANT_COLLECTION')"
            >
              <v-list-item-content>
                <v-list-item-title>Approve Collection</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/pending/warrant/collection"
              active-class="accent--text"
              v-if="$can('CAN_INITATE_WARRANT_COLLECTION')"
            >
              <v-list-item-content>
                <v-list-item-title
                  >Pending Collection Warrants</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/mark/warrant/collected"
              active-class="accent--text"
              v-if="$can('CAN_UPDATE_WARRANT')"
            >
              <v-list-item-content>
                <v-list-item-title>Update Collection</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/warrant/view"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_WARRANT')"
            >
              <v-list-item-content>
                <v-list-item-title>Paid/Collected Warrants</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              to="/warrant/utilization"
              active-class="accent--text"
              v-if="$can('CAN_VIEW_WARRANT_UTILIZATION_REPORT')"
            >
              <v-list-item-content>
                <v-list-item-title>EWarrants Utilization</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div
        v-if="
                $can('CAN_VIEW_MILLER_CHARGE') ||
                $can('CAN_VIEW_BROKER_CHARGE') ||
                $can('CAN_CREATE_MILLER_CHARGE') ||
                $can('CAN_UPDATE_MILLER_CHARGE') ||
                $can('CAN_VIEW_SOCIETY_CHARGE') ||
                $can('CAN_CREATE_SOCIETY_CHARGE') ||
                $can('CAN_APPROVE_SOCIETY_CHARGE') ||
                $can('CAN_VIEW_BROKER_CHARGE') ||
                $can('CAN_CREATE_BROKER_CHARGE') ||
                $can('CAN_APPROVE_BROKER_CHARGE') ||
                $can('CAN_VIEW_WAREHOUSE_CHARGE') ||
                $can('CAN_CREATE_WAREHOUSE_CHARGE') ||
                $can('CAN_APPROVE_WAREHOUSE_CHARGE')
              ">
        <v-list>
          <v-list-group no-action light style="margin-left: 2px">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="accent--text navtextgroup"
                    >Charges</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-icon slot="prependIcon" medium color="#733D29"
              >fas fa-list</v-icon
            >
            <!-- Miller -->
            <div
              v-if="
                $can('CAN_VIEW_MILLER_CHARGE') || $can('CAN_VIEW_BROKER_CHARGE')
              "
            >
              <v-list>
                <v-list-group
                  no-action
                  color="#733D29"
                  light
                  style="margin-left: 7px"
                  :class="currPath === 'reports' ? 'active' : ''"
                >
                  <template v-slot:activator>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="accent--text navtextgroup"
                          >Milling Charges</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <v-list-item
                    v-if="$can('CAN_CREATE_MILLER_CHARGE')"
                    to="/charge/milling_create"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Create/Edit Charge</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="$can('CAN_UPDATE_MILLER_CHARGE')"
                    to="/charge/milling_approve"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Approve Charge</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    to="/charge/milling_view"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>View Charges</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </v-list>
            </div>
            <!-- Society -->
            <div v-if="$can('CAN_VIEW_SOCIETY_CHARGE')">
              <v-list>
                <v-list-group
                  no-action
                  color="#733D29"
                  light
                  style="margin-left: 7px"
                  :class="currPath === 'reports' ? 'active' : ''"
                >
                  <template v-slot:activator>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="accent--text navtextgroup"
                          >Society Charges</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <v-list-item
                    v-if="$can('CAN_CREATE_SOCIETY_CHARGE')"
                    to="/charge/society_create"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Create/Edit Charge</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="$can('CAN_APPROVE_SOCIETY_CHARGE')"
                    to="/charge/society_approve"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Approve Charge</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    to="/charge/society_view"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>View Charges</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </v-list>
              <!-- <div class="linkseparator"></div> -->
            </div>

            <!-- Broker charges menu -->
            <div v-if="$can('CAN_VIEW_BROKER_CHARGE')">
              <v-list>
                <v-list-group
                  no-action
                  color="#733D29"
                  light
                  style="margin-left: 7px"
                  :class="currPath === 'reports' ? 'active' : ''"
                >
                  <template v-slot:activator>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="accent--text navtextgroup"
                          >Broker Charges</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <v-list-item
                    v-if="$can('CAN_CREATE_BROKER_CHARGE')"
                    to="/charge/broker_create"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Create/Edit Charge</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="$can('CAN_APPROVE_BROKER_CHARGE')"
                    to="/charge/broker_approve"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Approve Charge</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    to="/charge/broker_view"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>View Charges</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </v-list>
              <!-- <div class="linkseparator"></div> -->
            </div>
            <!-- Warehouse Charges menu -->
            <div
              v-if="
                $can('CAN_VIEW_WAREHOUSE_CHARGE') ||
                $can('CAN_VIEW_BROKER_CHARGE')
              "
            >
              <v-list>
                <v-list-group
                  no-action
                  color="#733D29"
                  light
                  style="margin-left: 7px"
                  :class="currPath === 'reports' ? 'active' : ''"
                >
                  <template v-slot:activator>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="accent--text navtextgroup"
                          >Warehouse Charges</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <v-list-item
                    v-if="$can('CAN_CREATE_WAREHOUSE_CHARGE')"
                    to="/charge/warehouse_create"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Create/Edit Charge</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="$can('CAN_APPROVE_WAREHOUSE_CHARGE')"
                    to="/charge/warehouse_approve"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Approve Charge</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    to="/charge/warehouse_view"
                    active-class="accent--text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>View Charges</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </v-list>
              <!-- <div class="linkseparator"></div> -->
            </div>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <!-- new payment -->
      <div v-if="canPerformPaymentFunc || canViewCommunalRate">
        <v-list>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Process payments</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <!-- Review this permission -->
            <v-list-item
              to="/eslip/getByStatus"
              active-class="primary--text"
              v-if="canInitiatePayment"
            >
              <v-list-item-content>
                <v-list-item-title>Pending Settlement</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">list</v-icon>
              </v-list-item-action>
            </v-list-item>

            <!-- Review this permission -->
            <v-list-item
              to="/eslip/getByApprovalStatus"
              active-class="primary--text"
              v-if="canApproveSettlement"
            >
              <v-list-item-content>
                <v-list-item-title>Pending Approval</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">playlist_add_check</v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item
              to="/broker/pendingTransactions"
              active-class="primary--text"
              v-if="canApproveSettlement"
            >
              <v-list-item-content>
                <v-list-item-title>Broker Transactions</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">playlist_add_check</v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item
              to="/growers-charge/pendingTransactions"
              active-class="primary--text"
              v-if="canApproveSettlement"
            >
              <v-list-item-content>
                <v-list-item-title>Settle Growers</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">playlist_add_check</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              to="/ccarf/setCommunalRate"
              active-class="accent--text"
              v-if="canViewCommunalRate"
            >
              <!--                          v-if="canViewFundsConversion"> find out how perm works-->
              <v-list-item-content>
                <v-list-item-title>Set Communal Rate Limit</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">list</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              to="/ccarf/conversionRate"
              active-class="accent--text"
              v-if="canViewConversionRate"
            >
              <!--                          v-if="canViewFundsConversion"> find out how perm works-->
              <v-list-item-content>
                <v-list-item-title>Farmer Funds Conversion</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">list</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>
      <div v-if="canPerformOrgFunc">
        <v-list>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Organization</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list-item
              to="/organization/create"
              active-class="primary--text"
              v-if="canCreateOrg"
            >
              <v-list-item-content>
                <v-list-item-title>Create</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">add</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              to="/organisation/approve/requests"
              active-class="primary--text"
              v-if="canApproveOrg"
            >
              <v-list-item-content>
                <v-list-item-title>Approve</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">playlist_add_check</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              to="/organisation/view/requests"
              active-class="primary--text"
              v-if="canViewOrg"
            >
              <v-list-item-content>
                <v-list-item-title>View</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">playlist_add_check</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="canPerformUserFunc">
        <v-list>
          <v-list-group
            prepend-icon="account_circle"
            no-action
            active-class="accent--text"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Users</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list-item
              to="/user/internal/create"
              v-if="canCreateUser"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Create</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">add</v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item
              to="/user/internal/view"
              v-if="canViewUser"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>View</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">list</v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item
              to="/user/internal/approve"
              v-if="canApproveUser"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Approve Internal Users</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">playlist_add_check</v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item
              to="/user/external/approve"
              v-if="canApproveExternalUser"
              active-class="accent--text"
            >
              <v-list-item-content>
                <v-list-item-title>Approve External Users</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="primary">playlist_add_check</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>

      <div v-if="canPerformSettingsFunc">
        <v-list>
          <v-list-group
            prepend-icon="settings"
            no-action
            active-class="secondary--text"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Settings</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list-group
              no-action
              sub-group
              value="true"
              active-class="secondary--text"
            >
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Roles</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                to="/admin/createrole"
                active-class="secondary--text"
              >
                <v-list-item-title>Create</v-list-item-title>
                <v-list-item-action>
                  <v-icon>add</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-list-item to="/admin/viewroles" active-class="secondary--text">
                <v-list-item-title>View</v-list-item-title>
                <v-list-item-action>
                  <v-icon>list</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-group>

            <v-list-group no-action sub-group value="true">
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-title>Permissions</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                to="/permission/create"
                active-class="secondary--text"
              >
                <v-list-item-title>Create</v-list-item-title>
                <v-list-item-action>
                  <v-icon>add</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-list-item to="/permission/view" active-class="secondary--text">
                <v-list-item-title>View</v-list-item-title>
                <v-list-item-action>
                  <v-icon>list</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-group>
          </v-list-group>
        </v-list>
        <div class="linkseparator"></div>
      </div>
    </v-navigation-drawer>
    <v-app-bar clipped-left app color="#FFFFFF" fixed dense elevation="1">
      <v-toolbar dense flat>
        <v-toolbar-title>
          <v-img src="@/assets/img/green.svg" width="270px"></v-img>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="selectAccountDialog = true">
          <v-icon color="primary" size="30"> swap_horiz</v-icon>
        </v-btn>
        <v-badge color="#733D29" overlap class="nav">
          <template v-slot:badge>
            <span>{{ notifications }}</span>
          </template>
          <v-icon color="#7BC243">notifications</v-icon>
        </v-badge>

        <div class="text-xs-left" style="margin-left: 40px; margin-top: 10px">
          <p class="name">{{ username }}</p>
          <p class="email text-truncate">
            {{ user.organisation.organisationName }}
          </p>
        </div>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="100"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn text dark v-on="on" icon>
              <v-icon color="#00513B"> account_circle</v-icon>
            </v-btn>
          </template>
          <v-card style="box-shadow: 10px 10px 40px #f2d0a7">
            <v-list>
              <div class="menuseparator"></div>
              <v-list-item @click="confirmLogOut">
                <v-list-item-title class="accent--text font-weight-bold"
                  >Logout</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-toolbar>
    </v-app-bar>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="body-2 accent--text font-weight-bold"
          >Log Out</v-card-title
        >
        <v-card-text class="accent--text">
          Are you sure you want to log out?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
                class="accent--text logoutbtn"
            text
            @click="dialog = false"
            :disabled="loggingout"
          >
            Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="#7BC243" class="white--text logoutbtn" @click="logout" :loading="loggingout" :disabled="loggingout"
            >Log Out</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="selectAccountDialog" persistent max-width="600">
      <v-card raised class="rounded-lg" min-height="100%" :loading="loading">
        <v-card-title class="headline mb-5">
          <v-row>
            <v-col cols="12" md="6"> Select Account </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="1">
              <v-btn icon @click="selectAccountDialog = false">
                <v-icon color="black">close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row
            justify="center"
            v-for="org in user.organisations"
            :key="org.id"
          >
            <v-col cols="12" md="10">
              <v-card
                v-if="org.id !== user.organisation.id"
                elevation="3"
                class="rounded-xl mb-10"
                ripple
                @click="triggerSwitchAccount(org)"
              >
                <v-card-text
                  ><h5 class="ml-2">{{ org.organisationName }}</h5></v-card-text
                >
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import config from '../config'

export default {
	name: 'NavigationMenu',
	data: function () {
		return {
			drawer: null,
			logoutTimer: null,
			inactivityTime: 15 * 60 * 1000, // 10 minutes in milliseconds
			menu: false,
			dialog: false,
			iconWidth: 40,
			iconHeight: 30,
			notifications: 0,
			permissions: [],
			selectAccountDialog: false,
			loading: false,
			loggingout: false
		}
	},
	mounted () {
		this.permissions = this.user.roleId.permissions
		// this.resetTimer()
	},
	computed: {
		...mapState({ user: (state) => state.user }),
		showEstateCuredMenu () {
			return this.canViewEstateMiller || this.canViewEstateBroker
		},
		canViewGrowers () {
			if (this.user.organisation.organisationType.name === 'MARKETER') {
				return false
			} else {
				return true
			}
		},
		canViewEstateBroker () {
			if (
				this.hasPerm('CAN_VIEW_CATALOGUE') ||
        this.hasPerm('CAN_UPLOAD_CATALOGUE') ||
        this.hasPerm('CAN_APPROVE_CATALOGUE')
			) {
				return true
			} else {
				return false
			}
		},
		canViewEstateMiller () {
			if (
				this.hasPerm('CAN_VIEW_PARCHMENT') ||
        this.hasPerm('CAN_UPLOAD_PARCHMENT') ||
        this.hasPerm('CAN_APPROVE_PARCHMENT')
			) {
				return true
			} else {
				return false
			}
		},
		canViewFarmers () {
			if (
				this.hasPerm('CAN_UPLOAD_FARMERS') ||
        this.hasPerm('CAN_APPROVE_FARMERS')
			) {
				return true
			} else {
				return false
			}
		},
		canViewReconFile () {
			if (this.hasPerm('CAN_VIEW_RECON_FILE')) {
				return true
			} else {
				return false
			}
		},
		canViewFundsConversion () {
			if (
				this.hasPerm('CAN_CREATE_CONVERSION_RATE') ||
        this.hasPerm('CAN_APPROVE_CONVERSION_RATE')
			) {
				return true
			} else {
				return false
			}
		},

		canUploadLimits () {
			if (
				this.hasPerm('CAN_UPLOAD_LIMITS') ||
        this.hasPerm('CAN_APPROVE_LIMITS')
			) {
				return true
			} else {
				return false
			}
		},
		canAccessFarmers () {
			if (
				this.hasPerm('CAN_UPLOAD_FARMERS') ||
        this.hasPerm('CAN_APPROVE_FARMERS') ||
        this.hasPerm('CAN_UPLOAD_LIMITS') ||
        this.hasPerm('CAN_APPROVE_LIMITS') ||
        this.hasPerm('CAN_GENERATE_SCHEDULE') ||
        this.hasPerm('CAN_APPROVE_SCHEDULE')
			) {
				return true
			} else {
				return false
			}
		},
		canViewConversionRate () {
			if (
				this.hasPerm('CAN_APPROVE_CONVERSION_RATE') ||
        this.hasPerm('CAN_CREATE_CONVERSION_RATE')
			) {
				return true
			} else {
				return false
			}
		},
		canViewCommunalRate () {
			if (
				this.hasPerm('CAN_APPROVE_COMMUNAL_RATE') ||
        this.hasPerm('CAN_SET_COMMUNAL_RATE')
			) {
				return true
			} else {
				return false
			}
		},
		canAccessCCARF () {
			if (
				this.hasPerm('CAN_VIEW_LOAN_REQUEST') ||
        this.hasPerm('CAN_UPLOAD_FARMERS') ||
        this.hasPerm('CAN_APPROVE_FARMERS') ||
        this.hasPerm('CAN_UPLOAD_LIMITS') ||
        this.hasPerm('CAN_APPROVE_LIMITS') ||
        this.hasPerm('CAN_CREATE_CHERRY_RATE') ||
        this.hasPerm('CAN_UPDATE_CHERRY_RATE') ||
        this.hasPerm('CAN_APPROVE_CHERRY_RATE') ||
        this.hasPerm('CAN_CREATE_CCARF_RATE') ||
        this.hasPerm('CAN_UPDATE_CCARF_RATE')
			) {
				return true
			} else {
				return false
			}
		},

		canViewStatutory () {
			if (
				this.hasPerm('CAN_CREATE_CHARGE') ||
        this.hasPerm('CAN_VIEW_CHARGE') ||
        this.hasPerm('CAN_UPDATE_CHARGE')
			) {
				return true
			} else {
				return false
			}
		},
		canApproveStatutory () {
			if (this.hasPerm('CAN_APPROVE_CHARGE')) {
				return true
			} else {
				return false
			}
		},
		canViewNonStatutory () {
			if (
				this.user.roleId.id === 39 ||
        this.user.roleId.id === 40 ||
        this.user.roleId.id === 41 ||
        this.user.roleId.id === 42
			) {
				return true
			} else {
				return false
			}
		},
		canApproveNonStatutory () {
			if (this.user.roleId.id === 40) {
				return true
			} else {
				return false
			}
		},
		canPerformChargesFunc () {
			if (this.canViewStatutory || this.canApproveStatutory) {
				return true
			} else {
				return false
			}
		},
		canCreateOrg () {
			if (this.hasPerm('CAN_CREATE_ORGANISATION')) {
				return true
			} else {
				return false
			}
		},
		canViewOrg () {
			if (
				this.hasPerm('CAN_VIEW_ORGANISATION') ||
        this.hasPerm('CAN_UPDATE_ORGANISATION')
			) {
				return true
			} else {
				return false
			}
		},

		canApproveOrg () {
			if (this.hasPerm('CAN_APPROVE_ORGANISATION')) {
				return true
			} else {
				return false
			}
		},
		canInitiatePayment () {
			if (this.hasPerm('CAN_VIEW_PAYMENT')) {
				return true
			} else {
				return false
			}
		},
		canApprovePayment () {
			if (this.hasPerm('CAN_APPROVE_PAYMENT')) {
				return true
			} else {
				return false
			}
		},
		canApproveSettlement () {
			if (this.hasPerm('CAN_APPROVE_SETTLEMENT')) {
				return true
			} else {
				return false
			}
		},
		canPerformOrgFunc () {
			if (this.canCreateOrg || this.canViewOrg || this.canApproveOrg) {
				return true
			} else {
				return false
			}
		},
		canPerformPaymentFunc () {
			if (this.canInitiatePayment || this.canApprovePayment) {
				return true
			} else {
				return false
			}
		},
		canCreateUser () {
			if (this.hasPerm('CAN_CREATE_INTERNALUSERS')) {
				return true
			} else {
				return false
			}
		},
		canViewUser () {
			if (this.hasPerm('CAN_VIEW_INTERNALUSERS')) {
				return true
			} else {
				return false
			}
		},
		canUpdateUser () {
			if (this.hasPerm('CAN_UPDATE_INTERNALUSERS')) {
				return true
			} else {
				return false
			}
		},
		canApproveUser () {
			if (this.hasPerm('CAN_APPROVE_INTERNALUSERS')) {
				return true
			} else {
				return false
			}
		},
		canUploadCherryDelivery () {
			if (
				this.hasPerm('CAN_UPLOAD_LIMITS') ||
        this.hasPerm('CAN_APPROVE_LIMITS')
			) {
				return true
			} else {
				return false
			}
		},
		canCreateCherryRate () {
			if (this.hasPerm('CAN_CREATE_CCARF_RATE')) {
				return true
			} else {
				return false
			}
		},
		canUpdateCherryRate () {
			if (this.hasPerm('CAN_UPDATE_CCARF_RATE')) {
				return true
			} else {
				return false
			}
		},
		canApproveCherryRate () {
			if (this.hasPerm('CAN_APPROVE_CCARF_RATE')) {
				return true
			} else {
				return false
			}
		},
		canApproveExternalUser () {
			if (this.hasPerm('CAN_APPROVE_EXTERNALUSERS')) {
				return true
			} else {
				return false
			}
		},
		canPerformUserFunc () {
			if (
				this.canCreateUser ||
        this.canViewUser ||
        this.canUpdateUser ||
        this.canApproveUser ||
        this.canApproveExternalUser
			) {
				return true
			} else {
				return false
			}
		},
		canPerformSettingsFunc () {
			if (
				this.hasPerm('CAN_CREATE_ROLE') ||
        this.hasPerm('CAN_UPDATE_ROLE') ||
        this.hasPerm('CAN_VIEW_ROLE')
			) {
				return true
			} else {
				return false
			}
		},
		canUploadDelivery () {
			if (
				this.hasPerm('CAN_UPLOAD_LIMITS') ||
        this.hasPerm('CAN_UPLOAD_CCARF_PARCHMENT') ||
        this.hasPerm('CAN_APPROVE_LIMITS') ||
        this.hasPerm('CAN_APPROVE_CCARF_PARCHMENT') ||
        this.hasPerm('CAN_CREATE_CCARF_RATE') ||
        this.hasPerm('CAN_UPDATE_CCARF_RATE')
			) {
				return true
			} else {
				return false
			}
		},
		canUploadCcarfParchmentDelivery () {
			if (
				this.hasPerm('CAN_UPLOAD_CCARF_PARCHMENT') ||
        this.hasPerm('CAN_APPROVE_CCARF_PARCHMENT')
			) {
				return true
			} else {
				return false
			}
		},
		canViewFcsLoanSchedule () {
			if (this.hasPerm('CAN_VIEW_FCS_LOAN_SCHEDULE')) {
				return true
			} else {
				return false
			}
		},
		username: function () {
			if (this.user) {
				return this.user.firstName + ' ' + this.user.lastName
			}
			return ''
		},
		email: function () {
			if (this.user && this.user.username.indexOf('@') === -1) {
				return this.user.username + '@co-opbank.co.ke'
			} else if (this.user) {
				return this.user.username
			}
			return ''
		},
		currPath: function () {
			if (
				this.$route.path === '/catalogue' ||
        this.$route.path.indexOf('catalogue') !== -1
			) {
				return 'catalogue'
			} else if (
				this.$route.path === '/auction/result' ||
        this.$route.path.indexOf('details') !== -1
			) {
				return 'auctiondetails'
			} else if (this.$route.path.indexOf('invoice') !== -1) {
				return 'invoice'
			} else if (
				this.$route.path === '/cleancoffee' ||
        this.$route.path.indexOf('cleancoffee') !== -1
			) {
				return 'cleancoffee'
			} else if (
				this.$route.path === '/parchment' ||
        this.$route.path.indexOf('parchment') !== -1
			) {
				return 'parchment'
			} else if (
				this.$route.path === '/farmers' ||
        this.$route.path.indexOf('farmers') !== -1
			) {
				return 'farmers'
			} else if (
				this.$route.path === '/estatecuredMiller' ||
        this.$route.path.indexOf('estatecuredMiller') !== -1
			) {
				return 'estatecuredMiller'
			} else if (
				this.$route.path === '/loan' ||
        this.$route.path.indexOf('loan') !== -1
			) {
				return 'loans'
			}
			return this.$route.path
		},
		orgType: function () {
			// 1 BUYER
			// 2 MILLER
			// 3 MARKETER
			// 4 FARMER_SOCIETY
			// 5 WAREHOUSE
			// 6 COOP
			// 7 NCE
			// for nce and internal users check the role
			// 15 helpdesk
			// 16 coopadmin
			// 17 systemadmin
			if (this.user.organisation === null) {
				if (this.user.roleId.id === 21) {
					return 16
				} else if (this.user.roleId.id === 22) {
					return 15
				} else if (this.user.roleId.id === 23) {
					return 17
				} else {
					return 0
				}
			} else {
				return this.user.organisation.organisationType.id
			}
		},
		isFCSManager: function () {
			return (
				this.user &&
        this.user.roleId &&
        (this.user.roleId.name === 'FCS MANAGER' ||
          this.user.roleId.id === 31 ||
          this.user.roleId.name === 'NCE_MAKER' ||
          this.user.roleId.name === 'NCE_CHECKER')
			)
		},
     	canInteractWithInvoice () {
			if (
				this.hasPerm('CAN_VIEW_BROKER_INVOICE') ||
        this.hasPerm('CAN_VIEW_WAREHOUSE_INVOICE') ||
        this.hasPerm('CAN_VIEW_NCE_INVOICE') ||
        this.hasPerm('CAN_VIEW_MILLER_INVOICE') ||
        this.hasPerm('CAN_VIEW_GROWER_INVOICE') ||
        this.hasPerm('CAN_CONFIRM_INVOICE') ||
        this.hasPerm('CAN_VERIFY_INVOICE') ||
        this.hasPerm('CAN_REJECT_INVOICE')

			) {
				return true
			} else {
				return false
			}
		},
	},
	methods: {
		...mapActions({
			logout: 'session/logout',
			switchAccount: 'session/switchAccount'
		}),
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		confirmLogOut () {
			this.dialog = true
		},
		resetTimer () {
			// Clear any existing timer
			if (this.logoutTimer) {
				clearTimeout(this.logoutTimer)
			}
			// Set a new timer
			this.logoutTimer = setTimeout(this.logout, this.inactivityTime)
		},
		logout () {
			this.loggingout = true
			const url = config.serverURI + '/token/logout/' + this.user.username
			this.user.organisation = {}
			console.log(this.user)
			axios
				.post(url)
				.then((response) => {
					this.message = response.data.message
					this.$store.commit('SET_USER', null)
					this.$store.commit('SET_TOKEN', null)
					if (window.localStorage) {
						window.localStorage.setItem('user', null)
						window.localStorage.setItem('token', null)
					}
					this.$router.push('/login')
					this.loggingout = false
					this.dialog = false
				})
				.catch((error) => {
					console.log('error', error.response)
					this.loggingout = false
					this.dialog = false
				})
		},
		profile () {},
		triggerSwitchAccount (org) {
			this.loading = true
			this.switchAccount(org)
				.then((response) => {
					console.log('Switch Account Response', response)
					this.loading = false
					this.selectAccountDialog = false
					this.$router.push('/dashboard')
					this.$store.commit('SET_USER', response.data.user)
					this.$store.commit('SET_TOKEN', response.data.token)
					if (window.localStorage) {
						window.localStorage.setItem(
							'user',
							JSON.stringify(response.data.user)
						)
						window.localStorage.setItem('token', response.data.token)
					}

					this.$store.dispatch(
						'alert/displayAlert',
						{
							snackbar: true,
							color: 'primary',
							message: 'Account switched'
						},
						{ root: true }
					)
				})
				.catch((error) => {
					console.log(error)
					this.loading = false
					this.selectAccountDialog = false
					if (error.response && error.response.status === 401) {
						this.$store.dispatch(
							'alert/displayAlert',
							{
								snackbar: true,
								color: 'error',
								message: error.response.data.message
							},
							{ root: true }
						)
					} else {
						this.$store.dispatch(
							'alert/displayAlert',
							{
								snackbar: true,
								color: 'error',
								message: error.response
									? error.response.data.message
									: 'Failed to switch'
							},
							{ root: true }
						)
					}
				})
		},
		beforeDestroy () {
			// Clear the timer when the component is destroyed
			if (this.logoutTimer) {
				clearTimeout(this.logoutTimer)
			}
		}
	}
}
</script>
<style scoped>
.linkseparator {
  width: 100%;
  margin-top: 5px;
  margin-bottom: 7px;
  height: 3px;
  content: "";
  background-image: linear-gradient(
    to right,
    #ffffff,
    #ffffff,
    #7bc243,
    #3e7326,
    #7bc243,
    #ffffff,
    #ffffff
  );
}

.active {
  background-image: linear-gradient(
    270deg,
    #ffffff 0%,
    #7bc24380 56%,
    #7bc243 100%
  );
}

.navtext {
  margin-left: 20px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
}

.navtextgroup {
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
}

.name {
  margin-bottom: 0px;
  font-size: 16px;
  color: #162614;
}

.email {
  margin-top: 0px;
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  color: #162614;
}

.menuseparator {
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  height: 3px;
  content: "";
  background-image: linear-gradient(
    270deg,
    #ffffff,
    #7bc243,
    #3e7326,
    #7bc243,
    #ffffff
  );
}

.logoutbtn {
  font-weight: 700;
  border-radius: 8px;
}
</style>
